import PropTypes from 'prop-types';
import { checkPasswordSecurity } from 'shared/utils';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    Container,
    MaterialIcon,
    Text
} from 'mol-ui';
import React, { useMemo } from 'react';

const PasswordSecurityCheck = ({ password = '' }) => {

    const { t } = useTranslation();
    const { dangerColor, successColor } = useTheme();

    const securityDisplay = useMemo(() => {
        const { checks } = checkPasswordSecurity(password);
        const defaultChecks = [{
            key: 'lowerCase',
            label: t('Debe contener al menos una letra minúscula')
        }, {
            key: 'upperCase',
            label: t('Debe contener al menos una letra mayúscular')
        }, {
            key: 'number',
            label: t('Debe contener al menos un número')
        }, {
            key: 'specialChar',
            label: t('Debe contener al menos un caracter especial')
        }, {
            key: 'minLength',
            label: t('Debe contener al menos 8 caracteres')
        }];
        return defaultChecks.map(check => ({
            ...check,
            status: checks[check.key]
        }));
    }, [password]);

    if (!password) return null;

    return (
        <Container alignItems="flex-start">
            {securityDisplay.map(({ key, label, status }) => (
                <Container
                    alignItems="center"
                    display="flex"
                    flexDirection="row"
                    gap="5px"
                    key={ key }
                >
                    <MaterialIcon
                        color={ status ? successColor : dangerColor }
                        icon={ status ? 'check_circle' : 'cancel' }
                    />
                    <Text
                        color={ status ? successColor : dangerColor }
                    >
                        {label}
                    </Text>
                </Container>
            ))}
        </Container>
    );
};

PasswordSecurityCheck.propTypes = {
    password: PropTypes.string
};

export default PasswordSecurityCheck;
